import { ContentHeaderComponent } from './content-header.component';

export default angular
  .module('sfMobile.components.content-header', [])
  .component('sfContentHeader', ContentHeaderComponent).name;
